export default __webpack_public_path__ + "static/media/clock.6835614a.svg";